export default __webpack_public_path__ + "static/media/affisch_2_a3-2.1436df05.png";